import ShapeBase from './ShapeBase';
import styles from '../styles.module.css';
import tools from '../tools';
import { type KeyPath } from '../collaboration/DataStoreRecordBehaviors';
import ImageCache from '../utils/images/imageCache';
import { svgToIcon } from '../utils/svg';

class ShapeSpriteIcon extends ShapeBase {
  width = 75;
  height = 75;

  // Cache of prepared images keyed sprite id.
  static images: Record<string, HTMLImageElement> = {};
  static placeholderImage: HTMLImageElement;

  imageCache: ImageCache;

  constructor(fabricObject) {
    super(fabricObject);
    fabricObject.uniformScaling = true;
    this.setupImageCache();
  }

  static shapeControls = this.createDefaultControls({ noRotate: true });

  hasEmbeddedText() {
    return false;
  }

  hasFixedDimensions() {
    return false;
  }

  tools() {
    return [tools.ToolChooseIcon];
  }

  toolButtonClass() {
    return styles.iconToolButton;
  }

  prepareImage() {
    this.imageCache.prepareImage();
  }

  wasSet(keyOrPath: KeyPath, value: unknown): void {
    super.wasSet(keyOrPath, value);
    if (keyOrPath === 'iconName') {
      this.setupImageCache();
    }
  }

  private imageReady() {
    // This callback only happens for the first object using the cache, but
    // other objects using the same image also need to be re-rendered, so we
    // must completely refresh the render.
    this.fabricObject.controller.renderManager.refreshAll();
    this.canvas?.requestRenderAll();
  }

  private setupImageCache() {
    if (this.fabricObject.iconName) {
      this.imageCache = new ImageCache(
        this.fabricObject.iconName,
        this.width,
        this.height,
        this.imageReady.bind(this)
      );
    }
  }

  hasExternalContent() {
    return this.canvas?.isHTMLExport();
  }

  renderExternalContent() {
    return svgToIcon(
      this.imageCache.getSvgString({ width: '100%', height: '100%' })!
    );
  }

  render(ctx: CanvasRenderingContext2D) {
    if (this.hasExternalContent()) return;

    if (!this.imageCache.image?.complete) {
      this.imageCache.renderPlaceholder(ctx, this);
      return;
    }

    const { width, height } = this;

    const x = -width / 2;
    const y = -height / 2;
    ctx.drawImage(this.imageCache.image, x, y, width, height);
  }
}

export default ShapeSpriteIcon;
